import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Netflix Clone" link="http://netflix-clone-8bf37.web.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Netflix Clone using React js. Use Hooks and use third party apis for display series and movies data.
    </ProjectCard>
    <ProjectCard title="E-commerce Site" link="http://onlinedigitalmarket.herokuapp.com/" bg="linear-gradient(to right, #1287A5 0%, #2B2B52 100%)" mdxType="ProjectCard">
Using Django make a E-commerce site. admin add,Edit,Delete,View product, view user information, view orders and revenue.integrate Razorpay as a payment gateway. 
    </ProjectCard>
    <ProjectCard title="WhatsApp Clone" link="https://whatsapp-ak-ca90c.web.app/" bg="linear-gradient(to right,#0ABDE3 0%, #8B78E6 100%)" mdxType="ProjectCard">
Start to Clone Web WhatsApp using Reactjs and Material ui and Backend in use MongoDb and Nodejs. use pusher for real time get message. 
    </ProjectCard>
    <ProjectCard title="Seller CMS" link="https://sellercms.herokuapp.com/" bg="linear-gradient(to right, #0A3D62 10%,  #FF3E4D 100%)" mdxType="ProjectCard">
integrate Social Authentication like Google, Twitter, Facebook with Django.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      